import { render, staticRenderFns } from "./external-sales-leads.vue?vue&type=template&id=54d00a75&"
import script from "./external-sales-leads.vue?vue&type=script&lang=js&"
export * from "./external-sales-leads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports